import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LngDetector from 'i18next-browser-languagedetector';
import { APP_TIMESTAMP } from '../util/constants';

export const BASE_NAMESPACES = [
  'common',
  'identification',
  'roots',
];

i18n
  .use(XHR)
  .use(LngDetector)
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      // where the detected/selected language is cached (persisted)
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 40320
    },
    // List the namespaces aka *.json files
    // A copy: i18next appends every namespace a component loads to this array.
    ns: [...BASE_NAMESPACES],
    debug: false,

    defaultNS: 'common',
    fallbackLng: 'fi',
    partialBundledLanguages: true,
    load: 'languageOnly',
    supportedLngs: ['fi', 'en', 'sv', 'ru'],
    nonExplicitSupportedLngs: true,
    backend: {
      loadPath: (process.env.NODE_ENV === 'dev') 
        ? '/i18n/{{lng}}/{{ns}}.json' 
        : `/i18n/v/${APP_TIMESTAMP}/{{lng}}/{{ns}}.json`
    }
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js